import { getUser } from '../../services/auth';
import { handleNetworkError } from '../../utils';
import formatDate from 'date-fns/format';
import { distanceInWordsToNow, differenceInDays } from 'date-fns';
import { fetchDashboardData, fetchAccounts, fetchAuditTrail, fetchNotifications, setNotificationReadStatus, fetchReconStatement, fetchLoanApplicationsByStatus } from '../../services/API';

export * from './savings';
export * from './users';
export * from './user-access';
export * from './transactions';
export * from './finlink-accounts';
export * from './loans';
export * from './bank-balances';
export * from './configs';
export * from './reminders';

export const setup = async({ commit }) => {
  try {
    let authUser = await getUser();
    if(authUser)
      authUser = JSON.parse(authUser);

    commit('SET_AUTH_USER', authUser);
    commit('SET_INITIALIZED');
  } catch (error) {
    handleNetworkError(error, "Error fetching users:");
  }
}

export const setAuthUser = async ({ commit }, authUser) => {
  try {
    commit('SET_AUTH_USER', authUser);
  } catch (error) {
    handleNetworkError(error, "Error fetching users:");
  }
}

export const getNotifications = async ({ commit }) => {
  commit('FETCHING_NOTIFICATIONS', true);
  try {
    const res = await fetchNotifications();
    const notifications = res.map((notification) => {
      const notificationDate = new Date(notification.createdAt);
      notification.date = formatDate(notificationDate, 'Do MMM YYYY');

      if(differenceInDays(notificationDate, new Date()) < 7)
        notification.date = distanceInWordsToNow(notificationDate, 'Do MMM YYYY') + " ago";

      return notification;
    });
    commit('SET_NOTIFICATIONS', notifications);
    commit('FETCHING_NOTIFICATIONS', false);
  } catch (error) {
    commit('FETCHING_NOTIFICATIONS', false);
    handleNetworkError(error, "Error fetching notifications:");
  }
}

export const markNotificationAsRead = async ({ commit }, notificationId) => {
  commit('UPDATE_NOTIFICATION', {notificationId, changes: {markingAsRead: true}});
  try {
    await setNotificationReadStatus(notificationId);
    const changes = {markingAsRead: false, readAt: new Date()};
    commit('UPDATE_NOTIFICATION', {notificationId, changes});
  } catch (error) {
    commit('UPDATE_NOTIFICATION', {notificationId, changes: {markingAsRead: false}});
    handleNetworkError(error, "Error marking notification as read:");
  }
}

export const getDashboardData = async ({ commit }) => {
  commit('FETCHING_DASHBOARD_DATA', true);

  try {
    const dashboardData = await fetchDashboardData();
    console.log("Dashboard data: ", dashboardData);
    commit('FETCHING_DASHBOARD_DATA', false);
    commit('SET_DASHBOARD_DATA', dashboardData);
  } catch (error) {
    commit('FETCHING_DASHBOARD_DATA', false);
    handleNetworkError(error, "Error fetching dashboard data:");
  }
}

export const getDashboardLoans = async ({ commit }) => {
  commit('FETCHING_DASHBOARD_LOANS', true);

  try {
    const res = await Promise.all([
      fetchLoanApplicationsByStatus("guaranteed"),
      fetchLoanApplicationsByStatus("disbursed")
    ]);
    const pending = res[0].data.map(loan => ({
        ...loan,
        updatedAt: formatDate(loan.updatedAt, 'Do MMM YYYY'),
      })
    );
    const pendingApproval = res[1].data.map(loan => ({
        ...loan,
        updatedAt: formatDate(loan.updatedAt, 'Do MMM YYYY'),
      })
    );

    commit('FETCHING_DASHBOARD_LOANS', false);
    commit('SET_DASHBOARD_LOANS', { pending, pendingApproval});
  } catch (error) {
    commit('FETCHING_DASHBOARD_LOANS', false);
    handleNetworkError(error, "Error fetching accounts:");
  }
}

export const getAccounts = async ({ commit }) => {
  commit('FETCHING_ACCOUNTS', true);

  try {
    const {data} = await fetchAccounts('main');
    commit('FETCHING_ACCOUNTS', false);
    commit('SET_ACCOUNTS', data.accounts);
  } catch (error) {
    commit('FETCHING_ACCOUNTS', false);
    handleNetworkError(error, "Error fetching accounts:");
  }
}

export const getAuditTrail = async ({ commit }, page) => {
  commit('FETCHING_AUDIT_TRAIL', true);

  try {
    let {data, metadata} = await fetchAuditTrail(page);
    data = data.map(entry => {
      entry.time = formatDate(new Date(entry.updatedAt), 'Do MMM YYYY, HH:mm:ss');
      return entry;
    });
    commit('FETCHING_AUDIT_TRAIL', false);
    commit('SET_AUDIT_TRAIL', {data, metadata});
  } catch (error) {
    commit('FETCHING_AUDIT_TRAIL', false);
    handleNetworkError(error, "Error fetching accounts:");
  }
}

export const getReconStatement = async ({ commit }, data) => {
  commit('FETCHING_RECON_STATEMENT', true);

  try {
    const response = await fetchReconStatement(data);
    commit('FETCHING_RECON_STATEMENT', false);
    commit('SET_RECON_STATEMENT', response.data);
  } catch (error) {
    commit('FETCHING_RECON_STATEMENT', false);
    handleNetworkError(error, "Error generating recon statement:");
  }
}